import { API, SITE } from 'utils/Helper';

export const getTransactions = async ({ tab, uid, ...filters }) => {
  const url = new URL(`${API}/api/${tab.toLowerCase()}New`);
  url.searchParams.append("uid", uid);
  Object.keys(filters).forEach(key => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
      url.searchParams.append(key, String(filters[key]));
    }
  });
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getBonusTypes = async (uid) => {
  const response = await fetch(`${API}/api/bonus-types?uid=${uid}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getManualTransactions = async ({ tab, uid, page, req_type }) => {
  const url = new URL(`${API}/api/manual-${tab.toLowerCase()}New`);
  url.searchParams.append("uid", uid);
  url.searchParams.append("req_type", req_type);
  url.searchParams.append("page", page);
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getCoinDetails = async (symbol) => {
  const response = await fetch(`${API}/payment/getCoinDetails`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ symbol }),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const createDeposit = async (data) => {
  const response = await fetch(`${API}/payment/createDeposit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getInrHistory = async (name) => {
  const response = await fetch(`https://api.winstreak.games/inrhistory`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({ name }),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const submitDepositUtr = async (data) => {
  const response = await fetch("https://api.winstreak.games/hr", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getExchangeRates = async () => {
  const response = await fetch(`${API}/rate`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getFakePlayersList = async () => {
  const response = await fetch(`${SITE}/list.json`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const transferVault = async (data) => {
  const { endpoint, ...payload } = data;
  const response = await fetch(`https://metananobackend.metablocktechnologies.org/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const swapCoins = async (data) => {
  const response = await fetch(`https://metananobackend.metablocktechnologies.org/api/swap`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const manualWithdrawal = async (data) => {
  const response = await fetch(`${API}/payment/api/withdrawal/manual`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getVaultData = async (data) => {
  const response = await fetch(`https://metananobackend.metablocktechnologies.org/vault-data`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getVaultDataLocal = async (data) => {
  const response = await fetch(`${API}/vault-data`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const transferVaultLocal = async (data) => {
  const { endpoint, ...payload } = data;
  const response = await fetch(`${API}/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getUserBets = async ({ tab, subTab, uid, ...filters }) => {
  const url = new URL(`${API}/api/user-bets`);
  url.searchParams.append("uid", uid);
  url.searchParams.append("tab", tab);
  url.searchParams.append("subTab", subTab || '');
  Object.keys(filters).forEach(key => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
      url.searchParams.append(key, String(filters[key]));
    }
  });
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};
